import { call, delay, put, takeLatest } from 'redux-saga/effects';
import { MODELS_ADD } from 'src/store/ActionTypes';

import * as api from 'src/store/api';

function* fetchSegments(action) {
  try {
    const { payload: query } = action;
    const segments = yield call(api.fetchSegments, query);
    yield put({
      type: MODELS_ADD.FETCH_SEGMENTS_SUCCEEDED,
      payload: segments,
    });
  } catch (e) {
    yield put({
      type: MODELS_ADD.FETCH_SEGMENTS_FAILED,
    });
  }
}

function* addModel(action) {
  try {
    yield call(api.addThinkalikeModel, action.payload);
    yield put({
      type: MODELS_ADD.ADD_MODEL_SUCCEEDED,
      payload: action.payload,
    });
  } catch (e) {
    yield put({
      type: MODELS_ADD.ADD_MODEL_FAILED,
    });
  } finally {
    yield delay(500);
    yield put({
      type: MODELS_ADD.UNSET,
      payload: 'addModelStatus',
    });
  }
}

function* fetchSegmentsSaga() {
  yield takeLatest(MODELS_ADD.FETCH_SEGMENTS, fetchSegments);
}

function* addModelSaga() {
  yield takeLatest(MODELS_ADD.ADD_MODEL, addModel);
}

export default [fetchSegmentsSaga(), addModelSaga()];
